export default __webpack_public_path__ + "static/media/logo.7c10ba0b.svg";